
import { React, useState, useEffect } from "react"
import { ArrowUpRight, ArrowDownRight } from "lucide-react"

const CryptoTicker = ({ cryptos = ["bitcoin", "kinesis-silver", "pax-gold"] }) => {
  const [prices, setPrices] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await fetch(
          `https://api.coingecko.com/api/v3/simple/price?ids=${cryptos.join(",")}&vs_currencies=usd&include_24hr_change=true`,
        )
        const data = await response.json()
        setPrices(data)
        setLoading(false)
      } catch (error) {
        console.error("Error fetching crypto prices:", error)
        setLoading(false)
      }
    }

    fetchPrices()
    const interval = setInterval(fetchPrices, 60000) // Update every minute

    return () => clearInterval(interval)
  }, [cryptos])

  if (loading) {
    return <div className="text-sm">Loading crypto prices...</div>
  }

  const cryptoLabels = {
    bitcoin: "Bitcoin",
    "pax-gold": "Gold",
    "kinesis-silver": "Silver",
  }

  return (
    <div className="flex space-x-4 items-center text-xs">
      {cryptos.map((crypto) => {
        const price = prices[crypto]
        if (!price) return null

        const priceChange = price.usd_24h_change
        const isPositive = priceChange >= 0

        return (
          <div key={crypto} className="flex items-center space-x-1">
            <span className="font-medium">{cryptoLabels[crypto] ?? crypto}</span>
            <span>${price.usd.toFixed(2)}</span>
            <span className={`flex items-center ${isPositive ? "text-green-500" : "text-red-500"}`}>
              {isPositive ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
              {Math.abs(priceChange).toFixed(1)}%
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default CryptoTicker
